'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _durationToSecs = require('./durationToSecs');

var _durationToSecs2 = _interopRequireDefault(_durationToSecs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (duration) {
    var d = +duration.slice(0, -1);
    var u = duration.slice(-1);
    return (0, _durationToSecs2.default)(d, u);
};


//////////////////
// WEBPACK FOOTER
// ./~/binary-utils/lib/duration/durationSecHelper.js
// module id = 21
// module chunks = 0